produtos.component('produtos.produtoDetalhesComponent', {
    templateUrl: 'produtos/produtoDetalhes/produtoDetalhes.html',
    controller: 'produtos.produtoDetalhesController',
    controllerAs: '$ctrl'
});

produtos.controller('produtos.produtoDetalhesController', ['$scope', 'coreLanguage', 'coreFb', 'coreToast', '$state', function($scope, $text, $fb, $toast, $state) {
    const $ctrl = this;
    $scope.$text = $text;

    const _getProduto=()=>{

        $fb.db.get(`cad_produtos/${$state.params.idProduto}`).then(doc=>{
            $ctrl.produto = doc;
            $state.params.showGlobalLoading = false;
        });
    };

    $ctrl.updateProduto=()=>{
        $ctrl.invalidNome = false;

        let obj = {
            nome: $ctrl.produto.data.nome,
            perfilUrl: $ctrl.produto.data.perfilUrl || null,
            capaUrl: $ctrl.produto.data.capaUrl || null
        };

        if(!obj.nome){
            $ctrl.invalidNome = true;
            return;
        }

        $state.params.showGlobalLoading = true;

        $fb.db.update($ctrl.produto.path, obj).then(()=>{
            $state.reload();
        });

    };

    $ctrl.setViewForm=(value)=>{
        $ctrl.viewForm=value;
    };

    $ctrl.setTab=(value)=>{
        $ctrl.tabView=value;
    };

    $ctrl.setEditBanner=(value)=>{
        $ctrl.editBanner = value;
    };

    $ctrl.updateBanner=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.produto.path, {banner: $ctrl.produto.data.banner}).then(okay=>{
            $ctrl.setEditBanner(false);
            $toast.success($text.updateSuccess);
            $state.params.showGlobalLoading = false;
        });
    };

    $ctrl.deleteBanner=()=>{
        $ctrl.produto.data.banner = {};
        $ctrl.updateBanner();
    };

    $ctrl.uploadBanner=(event)=>{
        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/banners/${$ctrl.produto.id}`, event.target.files[0]).then(url => {
            if(!$ctrl.produto.dados.banner){ $ctrl.produto.dados.banner = {}; }
            $ctrl.produto.dados.banner.imgUrl = url;
            $ctrl.loadingFile=false;
        });
    };

    $ctrl.uploadPerfil=(event)=>{
        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingPerfil=true;

        $fb.storage.upload(`/banners/${$ctrl.produto.id}`, event.target.files[0]).then(url => {
            $ctrl.produto.data.perfilUrl = url;
            $ctrl.loadingPerfil=false;
        });
    };
    
    $ctrl.uploadCapa=(event)=>{
        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return;
        }

        $ctrl.loadingCapa=true;

        $fb.storage.upload(`/banners/${$ctrl.produto.id}`, event.target.files[0]).then(url => {
            $ctrl.produto.data.capaUrl = url;
            $ctrl.loadingCapa=false;
        });
    };

    $ctrl.$onInit=()=>{
        $ctrl.setTab('conteudo');
        _getProduto();
    };

}]);